import React, { memo, useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Link, Route } from 'react-router-dom'
import { matchPath, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import styles from '../styles'
import { TMainProps, EAppStateActionTypes } from 'models'
import {
	TopResults,
	Companies,
	People,
	Articles,
	Teams,
	SearchMenuList,
} from '../components'
import Jobs from './jobs'
import { StoreValue } from 'store'

const tabsObj = {
	All: {
		link: '/all',
		component: TopResults,
		path: '/all/:postArticleSlug?',
		totalCount: 0,
	},
	Employers: {
		link: '/employers',
		component: Companies,
		path: '/employers',
		totalCount: 0,
	},
	People: {
		link: '/people',
		component: People,
		path: '/people',
		totalCount: 0,
	},
	Articles: {
		link: '/articles',
		component: Articles,
		path: '/articles/:postArticleSlug?',
		totalCount: 0,
	},
	Teams: {
		link: '/teams',
		component: Teams,
		path: '/teams',
		totalCount: 0,
	},
	Jobs: {
		link: '/jobs',
		component: Jobs,
		path: '/jobs',
		totalCount: 0,
	},
}

const useStyles = makeStyles(styles)

const MainView: React.FunctionComponent<TMainProps> = ({
	search,
	storeDispatch,
}) => {
	const {
		state,
		pathname,
	}: {
		state: { seeEmployersAndTeamsSection?: boolean }
		pathname: string
	} = useLocation()
	const isMobile = useMediaQuery('@media (max-width:650px)')
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	const pathRegex = new RegExp(`${i18n.language}/search/.*`)
	const handleSearchSection = useCallback(
		(section: string) => {
			storeDispatch &&
				storeDispatch({
					type: EAppStateActionTypes.updateSearchSection,
					section: section.replace('/', ''),
				})
		},
		[storeDispatch],
	)

	tabsObj.Employers.totalCount = search?.[0]?.company_count || 0
	tabsObj.People.totalCount = search?.[0]?.user_count || 0
	tabsObj.Articles.totalCount = search?.[0]?.article_count || 0
	tabsObj.Teams.totalCount = search?.[0]?.team_count || 0
	tabsObj.Jobs.totalCount = search?.[0]?.job_count || 0

	tabsObj.All.totalCount =
		tabsObj.Employers.totalCount +
		tabsObj.Articles.totalCount +
		tabsObj.People.totalCount +
		tabsObj.Teams.totalCount +
		tabsObj.Jobs.totalCount

	useEffect(() => {
		return () => {
			storeDispatch &&
				storeDispatch({
					type: EAppStateActionTypes.updateSearchSection,
					section: '',
				})
		}
	}, [storeDispatch])

	return (
		<>
			{pathRegex.test(pathname) && (
				<>
					{!isMobile ? (
						<div className={classes.tabs}>
							{Object.keys(tabsObj)
								.filter((item: string) => {
									if (
										state &&
										state.seeEmployersAndTeamsSection
									) {
										if (
											item === 'Employers' ||
											item === 'Teams'
										) {
											return true
										} else {
											return false
										}
									} else {
										return true
									}
								})
								?.map((item: any, index: number) => {
									return (
										<div key={`tab_container_${index}`}>
											<Link
												key={`tab_${index}`}
												to={{
													// @ts-ignore
													pathname: `/${i18n.language}/search${tabsObj[item].link}`,
													state: {
														seeEmployersAndTeamsSection:
															state &&
															state.seeEmployersAndTeamsSection
																? true
																: undefined,
													},
												}}
												className={classNames(
													classes.link,
													{
														[classes.active]:
															matchPath(
																pathname,
																{
																	// @ts-ignore
																	path: `/${i18n.language}/search${tabsObj[item].link}`,
																	exact: true,
																},
															),
													},
												)}
											>
												<span
													onClick={() =>
														handleSearchSection(
															// @ts-ignore
															tabsObj[item].link,
														)
													}
												>
													{t(
														// @ts-ignore
														item,
													)}
												</span>
											</Link>
											{!tabsObj.All.totalCount &&
											state?.seeEmployersAndTeamsSection ===
												true ? null : (
												<div
													className={
														classes.resultsCount
													}
												>
													{t('Total')}
													{': '}
													{
														// @ts-ignore
														tabsObj[item].totalCount
													}
												</div>
											)}
										</div>
									)
								})}
						</div>
					) : (
						<SearchMenuList
							handleSearchSection={handleSearchSection}
							searchTabs={tabsObj}
						/>
					)}
					<div className={classes.tabsContent}>
						{Object.keys(tabsObj)
							.filter((item: string) => {
								if (
									state &&
									state.seeEmployersAndTeamsSection
								) {
									if (
										item === 'Employers' ||
										item === 'Teams'
									) {
										return true
									} else {
										return false
									}
								} else {
									return true
								}
							})
							?.map((item: string, index: number) => {
								return (
									<Route
										key={`tab_content_${index}`}
										// @ts-ignore
										path={`/${i18n.language}/search${tabsObj[item].path}`}
										exact
										render={routeProps => {
											const TabComponent =
												// @ts-ignore
												tabsObj[item].component
											return (
												<TabComponent
													key={`tab_content${index}`}
													search={search}
													{...routeProps}
													{...(search && search)}
												/>
											)
										}}
									/>
								)
							})}
					</div>
				</>
			)}
		</>
	)
}

const Main = memo((props: any) => (
	<StoreValue keys={['storeDispatch']}>
		<MainView {...props} />
	</StoreValue>
))

export default Main
